import { useMemo, useState } from "react";
import { mockUsers } from "../../constants/mockdata";
const Users = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('All');
    const [selectedUsers, setSelectedUsers] = useState([]);

    const filteredUsers = useMemo(() => {
        return mockUsers
            .filter(user => statusFilter === 'All' || user.status === statusFilter)
            .filter(user => user.name.toLowerCase().includes(searchTerm.toLowerCase()) || user.email.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [searchTerm, statusFilter]);

    const handleSelectUser = (userId) => {
        setSelectedUsers(prev =>
            prev.includes(userId)
                ? prev.filter(id => id !== userId)
                : [...prev, userId]
        );
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedUsers(filteredUsers.map(user => user.id));
        } else {
            setSelectedUsers([]);
        }
    };

    // Placeholder function for sending mail
    const sendMail = (recipients) => {
        console.log("Sending mail to:", recipients);
        alert(`Sending mail to: ${recipients.join(', ')}`);
    };

    const handleBulkSend = () => {
        const emails = mockUsers.filter(user => selectedUsers.includes(user.id)).map(user => user.email);
        if (emails.length > 0) sendMail(emails);
    };

    return (
        <div className="bg-white shadow-lg rounded-xl">
            <div className="p-4 border-b flex flex-col sm:flex-row justify-between items-center gap-4">
                <div className="flex items-center gap-4">
                    <input type="text" placeholder="Search by name or email..." className="w-full sm:w-72 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500" onChange={(e) => setSearchTerm(e.target.value)} />
                    <select className="w-full sm:w-auto px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500" onChange={(e) => setStatusFilter(e.target.value)}>
                        <option>All</option><option>Active</option><option>Inactive</option>
                    </select>
                </div>
                <button
                    onClick={handleBulkSend}
                    disabled={selectedUsers.length === 0}
                    className="w-full sm:w-auto px-4 py-2 rounded-lg font-semibold text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
                >
                    Send Mail to Selected ({selectedUsers.length})
                </button>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                                    onChange={handleSelectAll}
                                    checked={filteredUsers.length > 0 && selectedUsers.length === filteredUsers.length}
                                />
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Customer</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total Spent</th>
                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {filteredUsers.map((user) => (
                            <tr key={user.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4">
                                    <input
                                        type="checkbox"
                                        className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                                        checked={selectedUsers.includes(user.id)}
                                        onChange={() => handleSelectUser(user.id)}
                                    />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <div className="text-sm font-medium text-gray-900">{user.name}</div>
                                        <div className="text-sm text-gray-500 ml-4">{user.email}</div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap"><span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${user.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{user.status}</span></td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-semibold">£{user.totalSpent.toFixed(2)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <button onClick={() => sendMail([user.email])} className="text-red-600 hover:text-red-900">Send Mail</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default Users;
